import { getAssetUrl } from '../../template.js';

/**
 * Get the page background image base URL.
 * Sometimes background can be defined as relative URL, then it's relative to this URL.
 * @param {object} template Parabo template data
 * @param {boolean} useServerAssets
 * @returns {string} Absolute URL to the base of relative URLs.
 */
const getBackgroundBaseUrl = (template, useServerAssets = false) => {
  return getAssetUrl(template, `/${useServerAssets ? 'assets_server' : 'assets_client'}/images/`);
};

export default getBackgroundBaseUrl;
